export function FormatDate(date?: Date) {
	if (!date) return;
	const newDate = new Date(date);
	const day = `0${newDate.getDate()}`.slice(-2);
	const month = `0${newDate.getUTCMonth() + 1}`.slice(-2);
	const year = newDate.getUTCFullYear();
	return `${day}/${month}/${year}`;
}